import store from "@/store"
import { baseUrl } from "@/request"
import { Toast } from "vant";

export function downloadGame(gameID) {
  console.log("进来下载功能了");
  if (!gameID) {
    Toast("无法下载该游戏,请联系客服");
    return;
  }
  window.open(
    baseUrl + '/api/v1/game/download?game_id=' + gameID + '&access_token=' + store.state.public_param.access_token, "_self")
}


